<template>
  <!-- <div ref="signinBtn" class="btn-sign-in">Sign In</div> -->
  <p id="signIcons" ref="signinBtn">
    <span id="signIcons">
      <img src="../module_user/assets/images/google.svg" alt srcset id="signIcons" />
    </span>
  </p>
</template>
<script>
export default {
  // props: ["corporateName"],
  props: {
    corporateName: {
      type: String,
      default: null,
    },
    parentID: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      mainRoutes: ['SignIn', 'SignUp', 'SMB Sign Up'],
      isPhysiotherapy : false
    }
  },
  mounted() {
    const parentIDRef = document.getElementById(this.parentID);
    let googleClientId = process.env.VUE_APP_GOOGLE_SSO_CLIENTID
    window.gapi.load("auth2", () => {
      const auth2 = window.gapi.auth2.init({
        client_id:
          googleClientId,
        cookiepolicy: "single_host_origin",
      });
      auth2.attachClickHandler(
        this.parentID ? parentIDRef : this.$refs.signinBtn,
        {},
        async (googleUser) => {
          if (this.mainRoutes.includes(this.$route.name)) {
            this.$emit("signedInUser", googleUser.getBasicProfile());
          }
          else {
            let user = googleUser.getBasicProfile();
            const data = await this.$store.dispatch("googleSSOlogin", {
              email: user.getEmail(),
              firstName: user.getGivenName(),
              lastName: user.getFamilyName(),
            });
            await this.redirect(data);
          }
        },
        (error) => this.$log.error(error)
      );
    });
  },
  methods: {
    async redirect(data) {
      if (data.corporate != null) {
        this.corporateName = data.corporate.redirect_url;
        await this.$router.push(`/${this.corporateName}`);
        return;
      }
      if (this.corporateName) {
        await this.$router.push(`/${this.corporateName}`);
        return;
      }
      this.isPhysiotherapy = data?.corporate?.theme === "physiotherapy";
      if (data.role === "Admin" || data.role === "Trainer") {
        await this.$router.push("/admin/trainer-profile");
      } else if (data.isFirstLogin === true) {
        await this.$router.push("/complete-profile");
      } else if (data.role === 'Enduser' && !data.isAnonymousUser) {
        await this.$router.push("/");
      } else {
        await this.$router.push(this.$router.currentRoute.query.returnUrl || "/");
      }
    }
  }

};
</script>
<style lang="sass" scoped>
</style>
